<template>
	<div class="content-builder">
		
		<div class="form-group">
			<textarea ref="code" class="code-mirror" v-html="content.body"></textarea>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import layoutMixin from '../../mixins/layout'
	import CodeMirror from 'codemirror'

	// load htmlmixed mode
	require('codemirror/mode/htmlmixed/htmlmixed')

	let CMEditor

	export default {
		mixins: [layoutMixin],
		methods: {
			getValue () {
				this.content.body = CMEditor.getValue()
				return this.content
			},
			setup () {
				console.log('BlackBox::setup')

				CMEditor = CodeMirror.fromTextArea(this.$refs.code, {
					lineNumbers: true,
					mode: 'htmlmixed'
				})

				$(this.$el).find('[data-image]').filemanager('image', {prefix: '/filemanager'})
				$(this.$el).find('[data-file]').filemanager('file', {prefix: '/filemanager'})
			}
		}
	}
</script>

<style lang="scss">
.CodeMirror {
	border: 1px solid #ddd;
	max-width: 1000px;
}
</style>